module.exports = __webpack_public_path__ + "static/media/CTLI_6-178w.76cb54d6.png";